import { useMobile } from "../../MobileContext";
import DesktopHeader from "../../components/DesktopHeader/DesktopHeader";
import InquiryDesktop from "../common/InquiryDesktop";
import React from "react";
import styles from "../../styles/PageLayout.module.css";

const FinancialInquiry = () => {
    const isMobile = useMobile();

    return (
        <div className={styles.mainContainer}>
            {isMobile ? (
                <> </>
            ) : (
                <DesktopHeader
                    role={"financial-manager"}
                    showNotification={false}
                />
            )}
            <div className={styles.contentContainer}>
                <div className={styles.rightSectionContainer}>
                    {isMobile ? (
                        <> </>
                    ) : (
                        <InquiryDesktop isNotificationPanelOpen={false} isFinancialManager={true} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default FinancialInquiry;